import { TopicConstants } from '../_constants';

export function topic(state = {}, action) {
  switch (action.type) {
    case TopicConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case TopicConstants.GETALL_SUCCESS:
      return {
        topics: action.topics
      };
    case TopicConstants.GETALL_FAILURE:
      return { 
        error: action.error
      };

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/topic.reducer.js